import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import SecondaryButton from '../components/common/SecondaryButton';

const Conversation = () => {
    const { t } = useTranslation();
    
    function getRandomItem(arr) {
        const randomIndex = Math.floor(Math.random() * arr.length);
        const item = arr[randomIndex];
        return item;
    }
    
    const [openDiv, setOpenDiv] = useState(false);
    const [randomItem, setRandomItem] = useState();
    
    const handleClick = () => {
        const item = getRandomItem(conversationQuestions);
        setRandomItem(item);
        setOpenDiv(true);
    };
    
    return (
        <div className="container d-flex flex-column justify-content-center gap-3 fade-in" style={{ padding: '1rem', maxWidth: '100%', overflowX: 'hidden' }}>
            <h1 className="text-center mt-4 pt-1" style={{ fontSize: 'clamp(1.25rem, 4vw, 1.75rem)', lineHeight: '1.4', marginBottom: '0.5rem' }}>{t('conversationH')}</h1>
            <div style={{ margin: '1.5rem 0', width: '100%' }} className="d-flex justify-content-center">
                <SecondaryButton
                    style={{
                        width: '100%',
                        maxWidth: '20rem',
                        padding: '1rem 2rem',
                        minHeight: '48px',
                        border: 'none',
                        color: '#35212A',
                        backgroundColor: 'rgb(255, 222, 243)',
                        fontSize: '1rem'
                    }}
                    handleFunc={handleClick}
                    buttonText="randomConversationButton"
                />
            </div>
            {openDiv && (
                <div
                    className="fade-in-up"
                    style={{
                        border: '3px solid #FFDEF3',
                        color: 'white',
                        padding: '1.25rem 1.5rem',
                        borderRadius: '0.5rem',
                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                        margin: '0 0.5rem',
                        transform: 'scale(1)',
                        transition: 'transform 0.2s ease'
                    }}
                >
                    <p style={{ margin: 0, color: 'black', fontSize: 'clamp(1rem, 3.5vw, 1.2rem)', lineHeight: '1.6' }}>
                        {t(randomItem)}
                    </p>
                </div>
            )}
            <ul className="d-flex flex-column gap-1" style={{ marginTop: '2rem', padding: '0', width: '100%' }}>
                {conversationQuestions.map((item, idx) => (
                    <li
                        style={{
                            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                            color: 'white',
                            padding: '1.25rem 1.5rem',
                            borderRadius: '0.5rem',
                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                            margin: '0 0.5rem',
                            transition: 'transform 0.2s ease, box-shadow 0.2s ease'
                        }}
                        key={idx}
                        onMouseEnter={(e) => {
                            if (window.matchMedia('(hover: hover)').matches) {
                                e.currentTarget.style.transform = 'translateY(-2px)';
                                e.currentTarget.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.15)';
                            }
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = '';
                            e.currentTarget.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.1)';
                        }}
                    >
                        <p style={{ color: 'black', margin: 0, fontSize: 'clamp(0.95rem, 3vw, 1.1rem)', lineHeight: '1.6' }}>
                            {idx + 1}. {t(item)}
                        </p>
                    </li>
                ))}
            </ul>
        </div>
    );
};

const conversationQuestions = [
    'conv-1',
    'conv-2',
    'conv-3',
    'conv-4',
    'conv-5',
    'conv-6',
    'conv-7',
    'conv-8',
    'conv-9',
    'conv-10',
    'conv-11',
    'conv-12',
    'conv-13',
    'conv-14',
    'conv-15',
    'conv-16',
    'conv-17',
    'conv-18',
    'conv-19',
    'conv-20',
    'conv-21',
    'conv-22',
    'conv-23',
    'conv-24',
    'conv-25',
    'conv-26',
    'conv-27',
    'conv-28',
    'conv-29',
    'conv-30',
    'conv-31',
    'conv-32',
    'conv-33',
    'conv-34',
    'conv-35',
    'conv-36',
    'conv-37',
    'conv-38',
    'conv-39',
    'conv-40',
    'conv-41',
    'conv-42',
    'conv-43',
    'conv-44',
    'conv-45',
    'conv-46',
    'conv-47',
    'conv-48',
    'conv-49',
    'conv-50'
];

export default Conversation;

